import { ref } from 'vue'
import { defineStore } from 'pinia'

const LS_KEY = 'lp-pending-achievement-notifications'

export const useNotifyQueue = defineStore('notify-queue', () => {
  const pending = ref([])

  function load() {
    try {
      const raw = localStorage.getItem(LS_KEY)
      pending.value = raw ? JSON.parse(raw) : []
    } catch {
      pending.value = []
    }
  }

  function persist() {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(pending.value))
    } catch {
      /* localStorage unavailable */
    }
  }

  function enqueue(item) {
    const id = item?.id
    if (id != null && pending.value.some((p) => p?.id === id)) {
      return
    }
    pending.value.push(item)
    persist()
  }

  function drain() {
    const items = pending.value.slice()
    pending.value = []
    persist()
    return items
  }

  return { pending, load, persist, enqueue, drain }
})
